import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold py-4 fs-6 w-300px profile-menu",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "menu-item px-3" }
const _hoisted_3 = { class: "menu-content d-flex align-items-center px-3" }
const _hoisted_4 = { class: "symbol symbol-50px me-5" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "d-flex flex-column" }
const _hoisted_7 = { class: "fw-bolder d-flex align-items-center fs-5" }
const _hoisted_8 = { class: "fw-bold text-muted text-hover-primary fs-7 text-break" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1)
const _hoisted_10 = { class: "menu-item px-5 my-1" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "las la-tools fs-2x me-2 text-gray-700" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Settings ")
const _hoisted_13 = { class: "menu-item px-5" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "las la-sign-out-alt fs-2x me-2 text-gray-700" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Log Out ")
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            class: "rounded-circle",
            alt: "Logo",
            src: _ctx.imgSrc ? _ctx.imgSrc : 'media/misc/user-profile.svg'
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.currentUser.firstName + " " + _ctx.currentUser.lastName), 1),
          _createElementVNode("a", _hoisted_8, _toDisplayString(_ctx.currentUser.email), 1)
        ])
      ])
    ]),
    _hoisted_9,
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_router_link, {
        to: "/accountsettings",
        class: "menu-link px-5"
      }, {
        default: _withCtx(() => [
          _hoisted_11,
          _hoisted_12
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.signOut())),
        class: "menu-link px-5"
      }, _hoisted_16)
    ])
  ]))
}